(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["region-picker-modal"] && !Shopify.designMode) return;
  try {
    
  class RegionPickerModal extends HTMLElement {
    static storageKey = 'bb::region-picker-modal';
    static sessionKey = 'bb::region-picker-modal:no-suggestion';
    static interactionEvents = ['pointerdown', 'pointermove', 'touchstart', 'wheel', 'keydown'];

    // Search, ads and shopping crawlers, link previews, speed tests and any browser driven by automation.
    // Phones of the brand Cubot carry "bot" in their user agent, so that one is taken out first.
    static isAutomated() {
      const userAgent = navigator.userAgent.replace(/cubot/gi, '');

      return navigator.webdriver === true || /bot|crawl|spider|slurp|google-|-google|googleother|bingpreview|facebookexternalhit|whatsapp|lighthouse|pagespeed|headless|ptst|gtmetrix|pingdom/i.test(userAgent);
    }

    connectedCallback() {
      this.dialog = this.querySelector('dialog');

      if (!this.dialog) {
        return;
      }

      this.form = this.querySelector('form');
      this.countrySelect = this.querySelector('[name="country_code"]');
      this.languageSelect = this.querySelector('[name="locale_code"]');
      this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

      this.dialog.addEventListener('click', this._onClick.bind(this));
      this.dialog.addEventListener('close', this._onClose.bind(this));
      this.countrySelect.addEventListener('change', () => this._renderLanguages(this.languageSelect.value));
      this.form.addEventListener('submit', this._onSubmit.bind(this));

      if (this.isDesignMode) {
        this._onSectionSelect = (event) => event.detail.sectionId === this.getAttribute('section-id') && this.open();
        this._onSectionDeselect = (event) => event.detail.sectionId === this.getAttribute('section-id') && this.dialog.close();
        document.addEventListener('shopify:section:select', this._onSectionSelect);
        document.addEventListener('shopify:section:deselect', this._onSectionDeselect);
        return;
      }

      if (RegionPickerModal.isAutomated() || this._remembered()) {
        return;
      }

      this._onPageShow = this._onPageShow.bind(this);
      window.addEventListener('pageshow', this._onPageShow);
      this._waitForVisitor();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:select', this._onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this._onSectionDeselect);
      window.removeEventListener('pageshow', this._onPageShow);
      this._stopWaiting();
    }

    // The back button can bring this page back exactly as it was left: modal open, confirm button already used
    _onPageShow(event) {
      if (!event.persisted) {
        return;
      }

      this.form.querySelector('[type="submit"]').disabled = false;

      if (this._remembered()) {
        this.dialog.close();
      }
    }

    // Not every renderer names itself (Lighthouse and PageSpeed Insights use a plain Chrome user agent), but none of them
    // moves a mouse, touches the screen or presses a key. Nothing is requested or shown before a real visitor does.
    _waitForVisitor() {
      this._onInteraction = (event) => {
        if (!event.isTrusted) {
          return;
        }

        this._stopWaiting();
        this._suggest().catch((error) => console.error('region-picker-modal: could not load suggestions', error));
      };

      RegionPickerModal.interactionEvents.forEach((name) => window.addEventListener(name, this._onInteraction, { passive: true }));
    }

    _stopWaiting() {
      RegionPickerModal.interactionEvents.forEach((name) => window.removeEventListener(name, this._onInteraction));
    }

    open() {
      if (this.dialog.open) {
        return;
      }

      this.dialog.showModal();
      document.documentElement.classList.add('is-locked');
    }

    async _suggest() {
      const currentCountry = this.getAttribute('country');
      const currentLanguage = this.getAttribute('language');
      const context = `${currentCountry}:${currentLanguage}`;

      if (this._hasNoSuggestion(context)) {
        return;
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const params = new URLSearchParams({
        'country[enabled]': 'true',
        'country[exclude]': currentCountry,
        'language[enabled]': 'true',
        'language[exclude]': currentLanguage,
      });

      const response = await fetch(`${root}browsing_context_suggestions.json?${params}`);

      if (!response.ok) {
        return;
      }

      const { suggestions = [] } = await response.json();

      // Most visitors never get a suggestion, so the answer is kept for the session instead of asking again on every page
      if (!this._preselect(suggestions, currentCountry, currentLanguage)) {
        this._rememberNoSuggestion(context);
        return;
      }

      await this._translate(this.languageSelect.value, currentLanguage);
      this.open();
    }

    // Returns false when there is nothing to suggest
    _preselect(suggestions, currentCountry, currentLanguage) {
      const parts = suggestions.length > 0 ? suggestions[0].parts : null;

      if (!parts) {
        return false;
      }

      let country = parts.country ? parts.country.handle : currentCountry;

      if (!this.data.languages[country]) {
        country = currentCountry;
      }

      if (country === currentCountry && !this.hasAttribute('language-only')) {
        return false;
      }

      this.countrySelect.value = country;
      this._renderLanguages(parts.language ? parts.language.handle : currentLanguage, currentLanguage);

      return country !== currentCountry || this.languageSelect.value !== currentLanguage;
    }

    // Keeps the wanted language when the country offers it, then the fallback, then the country's first language
    _renderLanguages(wanted, fallback) {
      const languages = this.data.languages[this.countrySelect.value] || [];
      const codes = languages.map(([code]) => code);
      const selected = [wanted, fallback].find((code) => codes.includes(code)) || codes[0];

      this.languageSelect.replaceChildren(...languages.map(([code, name]) => new Option(name, code, code === selected, code === selected)));
    }

    // The page is rendered in the current language, so the texts are taken from the same section rendered in the suggested one
    async _translate(language, currentLanguage) {
      const rootUrl = this.data.rootUrls[language];

      if (language === currentLanguage || !rootUrl) {
        return;
      }

      try {
        const response = await fetch(`${rootUrl}?section_id=${encodeURIComponent(this.getAttribute('section-id'))}`);

        if (!response.ok) {
          return;
        }

        const translated = new DOMParser().parseFromString(await response.text(), 'text/html');

        // A redirect or password page answers with 200 too, so the texts are only swapped when the modal is really in there
        if (!translated.querySelector('.region-picker-modal')) {
          return;
        }

        this.querySelectorAll('[data-i18n]').forEach((element) => {
          const source = translated.querySelector(`[data-i18n="${element.dataset.i18n}"]`);

          if (source) {
            element.textContent = source.textContent;
          }
        });

        Array.from(this.countrySelect.options).forEach((option) => {
          const source = translated.querySelector(`[name="country_code"] option[value="${option.value}"]`);

          if (source) {
            option.textContent = source.textContent;
          }
        });

        const closeLabel = translated.querySelector('.region-picker-modal__close');

        if (closeLabel) {
          this.querySelector('.region-picker-modal__close').setAttribute('aria-label', closeLabel.getAttribute('aria-label'));
        }

        this.dialog.lang = language;
      } catch (error) {
        console.error('region-picker-modal: could not load translated texts', error);
      }
    }

    _onClick(event) {
      if (event.target.closest('[data-action="close"]')) {
        this.dialog.close();
        return;
      }

      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        const isInside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;

        if (!isInside) {
          this.dialog.close();
        }
      }
    }

    _onClose() {
      if (!document.querySelector('.modal[aria-hidden="false"]')) {
        document.documentElement.classList.remove('is-locked');
      }

      if (!this._remembered()) {
        this._remember('dismissed');
      }
    }

    _onSubmit() {
      this._remember('confirmed');
      this.form.querySelector('[type="submit"]').disabled = true;
    }

    _remembered() {
      try {
        return localStorage.getItem(RegionPickerModal.storageKey) !== null;
      } catch (error) {
        return false;
      }
    }

    _remember(value) {
      if (this.isDesignMode) {
        return;
      }

      try {
        localStorage.setItem(RegionPickerModal.storageKey, value);
      } catch (error) {}
    }

    // Tied to the storefront's country and language, as the answer changes once the visitor switches either
    _hasNoSuggestion(context) {
      try {
        return sessionStorage.getItem(RegionPickerModal.sessionKey) === context;
      } catch (error) {
        return false;
      }
    }

    _rememberNoSuggestion(context) {
      try {
        sessionStorage.setItem(RegionPickerModal.sessionKey, context);
      } catch (error) {}
    }
  }

  if (!customElements.get('region-picker-modal')) {
    customElements.define('region-picker-modal', RegionPickerModal);
  }

  } catch(e) { console.error(e); }
})();
})();
